import "./view.scss";

document.addEventListener('keydown', (event) => {
    if (event.target.matches('.accordion-summary') && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        event.target.click(); // Simulates a click
    }
});